import Vue from 'vue'
import VueRouter from 'vue-router'
import Ingest from '../views/Ingest.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/ingest',
    name: 'Ingest',
    component: Ingest,
  },
  {
    path: '/manage/users',
    name: 'User Management',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/UserManagement.vue'),
  },
  {
    path: '/manage/fields',
    name: 'Field Mapping',
    component: () => import('../views/FieldsManagement.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
